export default {
  document: "Dokument",
  notes: "Notizen",
  online_since: "Online seit dem",
  file: "Datei",
  note: "Notiz",
  delete_document: "Dokument löschen",
  document_remove_confirm: "Möchten Sie dieses Dokument wirklich löschen?",
  note_remove_confirm: "Möchten Sie diese Notiz wirklich löschen?",
  document_remove_success: "Ihr Dokument wurde erfolgreich gelöscht!",
  note_remove_success: "Ihre Notiz wurde erfolgreich gelöscht!",
  document_remove_error: "Ups, beim Löschen ist ein Fehler aufgetreten",
  document_success: "Ihr Dokument wurde erfolgreich gesendet!",
  note_success: "Ihre Notiz wurde erfolgreich gesendet!",
  new_doc: "Dokument hinzufügen",
  new_note: "Notiz hinzufügen",
  new_doc_title: "Neues Dokument",
  new_note_title: "Neue Notiz",
  file_integrate_learning_book: "Die Datei (PDF) in den Inhalt des Ausbildungshefts integrieren",
  email_notif: "E-Mail-Benachrichtigung",
  notes_summary: "Notizen und Zusammenfassung",
  by: "Von",
  on: "Am",
  pedagogicDocuments: "Pädagogische Dokumente",
  generalDocuments: "Allgemeine Dokumente",
  globalDocuments: "Herunterzuladende Dokumente",
  otherDocuments: "Weitere Dokumente",
  "Documents to download": "Herunterzuladende Dokumente",
  Watch: "Anzeigen",
  Download: "Herunterladen",
  none_document: "Kein Dokument verfügbar",
  none_pedagogic: "Kein pädagogisches Dokument verfügbar",
  none_note: "Keine Notiz verfügbar",
};
